import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';

import { MdOutlineAdd, MdRemove } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';
import useAuth from '../../hooks/useAuth';


const EditFooter = () => {
    const { auth } = useAuth();

  const navigate = useNavigate();
  const {id} = useParams();

  const [footerInfo, setFooterInfo] = useState({})

  const [locList, setLocList] = useState([{ id: uuidv4(), footerLocations: ""}])
  const [focList, setFocList] = useState([{id: uuidv4(), focusArea: ""}])


  const handleLocationChange = (index, e ) => {
    const { name, value } = e.target;
    
    const newInputFields = locList.map(i => {
      if(index === i.id) {
        i[name] = value
      }
      return i;
    })
   
    setLocList(newInputFields);
  };


  const handleRemoveLocationsField = (index) => {
    const list = JSON.parse(JSON.stringify([...locList])) // [...locList];
    list.splice(index, 1);
    setLocList(list);
  };

  const handleAddLocationsField = () => {
    setLocList([...locList, { id: uuidv4(), footerLocations: "" }]);
  };


  // Focus Area Section
  const handleFocusAreaChange = ( index, e) => {
    const { name, value } = e.target;

    const newFocusArea = focList.map(i => {
      if(index === i.id) {
        i[name] = value
      }
      return i;
    })
    setFocList(newFocusArea);
  };

  const handleRemoveFocusField = (index) => {
    const list = [...focList];
    list.splice(index, 1);
    setFocList(list);
  };

  const handleAddFocusField = () => {
    setFocList([...focList, { id: uuidv4(), focusArea: "" }]);
  };

  const allLocations = Array.prototype.map.call(locList, function(item) { return item.footerLocations; }).join(",");
  const allFocusArea = Array.prototype.map.call(focList, function(item) { return item.focusArea; }).join(",");


  const getData = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/footers/find-footer/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })
          
            setFooterInfo(res.data);
            let locationlist = [];
            res.data.footerLocations.split(",").map(loc => locationlist.push({id: uuidv4() , footerLocations: loc}));
            setLocList(locationlist)

            let focusList = [];
            res.data.focusArea.map(foc => focusList.push({id: uuidv4() , focusArea: foc}));
            setFocList(focusList)

        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
      }
    

    useEffect(() => {
      getData();
     
    },[id])

   
    // ** States
   let initialState = footerInfo;


    const handleChange = (event) => {
        const { value, name } = event.target
        setFooterInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleUpdateClick = async (event) => {
        event.preventDefault();
        // let footerTagLine = footerInfo.footerTagLine;
        // let footerDesc = footerInfo.footerDesc;

        const formData = new FormData();
        formData.append('footerEmail', footerInfo.footerEmail);
        formData.append('footerPhone', footerInfo.footerPhone);
        formData.append('footerAddress', footerInfo.footerAddress);
        formData.append('footerLocations', allLocations);
        formData.append('focusArea', allFocusArea);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/footers/update-footer/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/footer/view')


        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/footer/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit Footer Information</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='footerEmail'>
                Email <span className='text-danger'>*</span>
              </Label>
              <Input
                id='footerEmail'
                type='email'
                className='me-1'
                name='footerEmail'
                required={true}
                value={footerInfo.footerEmail}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='footerAddress'>
                Address <span className='text-danger'>*</span>
              </Label>
              <Input
                id='footerAddress'
                type='textarea'
                className='me-1'
                name='footerAddress'
                required={true}
                value={footerInfo.footerAddress}
                onChange={handleChange}
                
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='footerPhone'>
                Phone <span className='text-danger'>*</span>
              </Label>
              <Input
                id='footerPhone'
                type='text'
                className='me-1'
                name='footerPhone'
                required={true}
                value={footerInfo.footerPhone}
                onChange={handleChange}
                
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='footerLoc'>
                Locations Serving <span className='text-danger'>*</span>
              </Label>
              {
                locList &&  locList.map((inputField, index) => (
                    <Row key={inputField.id}>
                        <Col sm='12' md='10' lg='10'>
                        <div>
                            <Input
                                id='footerLoc'
                                type='text'
                                name="footerLocations"
                                value={inputField.footerLocations}
                                onChange={event => handleLocationChange(inputField.id, event)}
                                required={true}
                            />  
                        </div>
                        </Col>
                        <Col sm='12' md='1' lg='1'>
                        <div>
                        
                        {
                          locList && locList.length - 1 === index && (
                            <Button
                                block
                                color="success"
                                onClick={handleAddLocationsField}
                                >
                                <MdOutlineAdd />
                            </Button>
                          )
                        }
                        
                        </div>

                        </Col>
                        <Col sm='12' md='1' lg='1'>
                        <div  className='mb-2'>
                        {
                          locList.length > 1 &&  <Button
                                block
                                color="danger"
                                onClick={(e) => handleRemoveLocationsField(index)}
                                >
                                <MdRemove />
                            </Button>
                        }
                           
                        </div>
                        </Col>
                    </Row>
                   
                    )) 
                
              }
            
            </div>


            <div className='mb-1'>
              <Label className='form-label' for='focusArea'>
                Focus Area <span className='text-danger'>*</span>
              </Label>
              { focList && focList.map((inputField, index) => (
                    <Row key={inputField.id}>
                          <Col sm='12' md='10' lg='10'>
                        <div>
                            <Input
                                id='focusAra'
                                type='text'
                                name="focusArea"
                                value={inputField.focusArea}
                                onChange={event => handleFocusAreaChange(inputField.id, event)}
                                required={true}
                            />  
                        </div>
                        </Col>
                        <Col sm='12' md='1' lg='1'>
                        <div>
                        {
                          focList && focList.length-1 === index && (
                            <Button
                                block
                                color="success"
                                onClick={handleAddFocusField}
                                >
                                <MdOutlineAdd />
                            </Button>
                          )
                        }
                           
                        </div>
                        </Col>
                        <Col sm='12' md='1' lg='1'>
                        <div className='mb-2'>
                        {
                          focList.length > 1 &&  <Button
                                block
                                color="danger"
                                onClick={(e) => handleRemoveFocusField(index)}
                                >
                                <MdRemove />
                            </Button>
                        }
                           
                        </div>
                        </Col>
                    </Row>
                   
                    )) 
                }
            </div>

           
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={handleUpdateClick}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={handleReset}
                  >
                    Cancel & go to list
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    
    </div>
  );
};

export default EditFooter;
